module.exports = __webpack_public_path__ + "img/kuaijiezhifu.a070ff7a.jpg";